import React, { useEffect } from 'react';

import ScenarioPlanner from './component';
import { track } from '../../../utils/tracking';
import { StyledDropdown, ViewAccessWrapper, BasicViewHeader } from '../../components';
import { TreeTableLoader } from '../../components/loaders';
import { MARKETING_MIX_MODELING } from '../../constants/views';
import { FeatureAliasesProvider } from '../../context/MMMFeatureAliases';
import { useModelData, useModelResponseCurves } from '../MarketingMixModeling/hooks/useModelData';
import { useModelRuns } from '../MarketingMixModeling/hooks/useModelRuns';

const ScenarioPlannerWrapper = () => {
  const { selectedExecDt, setSelectedExecDt, modelOptions, modelRuns } = useModelRuns();
  const { rawData, trainingInfo, seasonality } = useModelData(selectedExecDt, modelRuns);
  const { responseCurves, loading } = useModelResponseCurves(rawData);

  useEffect(() => {
    track('mmm.scenario_planner.view');
  }, []);

  const onModelChange = (e, { value }) => {
    setSelectedExecDt(value);
    track('mmm.scenario_planner.select_model');
  };

  return (
    <>
      <BasicViewHeader
        header="Scenario Planner"
        subheader="Build a media plan by exploring different marketing scenarios"
      />
      <StyledDropdown
        label="Model"
        fluid={false}
        options={modelOptions}
        value={selectedExecDt}
        onChange={onModelChange}
      />
      {loading ? <TreeTableLoader /> : <ScenarioPlanner {...{ rawData, trainingInfo, responseCurves, seasonality }} />}
    </>
  );
};

const ScenarioPlannerAccess = () => (
  <FeatureAliasesProvider>
    <ViewAccessWrapper
      viewName={MARKETING_MIX_MODELING}
      viewComponent={<ScenarioPlannerWrapper />}
    />
  </FeatureAliasesProvider>
);

export default ScenarioPlannerAccess;
